import { logger } from "@pexip-engage-public/plugin-utils";

import { initialize } from "./initialize";

const currentScript =
  document.currentScript instanceof HTMLScriptElement ? document.currentScript : null;

if (currentScript) {
  if (window.document.readyState === "loading") {
    // Loading hasn't finished yet
    window.document.addEventListener("DOMContentLoaded", () => initialize(currentScript));
  } else {
    // `DOMContentLoaded` has already fired
    initialize(currentScript);
  }
} else {
  logger.error("Failed to find currently executing script, not initializing.");
}
